module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-01-jp.cc7a665f32178037a0c918195d3623d1.png";